<template>
    <div class="btnlike">
        <button type="button" class="btn-groupaction-sm bg-150 btn-collapse-xs" @click.prevent.stop="onClick($event)">
            <i class="far fa-fw fa-calendar mr-hf"></i>
            <span class="btn-text" v-if="dateFilter.mode == 'last30'">Last 30 days</span>
            <span class="btn-text" v-if="dateFilter.mode == 'last90'">Last 90 days</span>
            <span class="btn-text" v-if="dateFilter.mode == 'last12'">Last 12 months</span>
            <span class="btn-text" v-if="dateFilter.mode == 'last24'">Last 24 months</span>
            <span class="btn-text" v-if="dateFilter.mode == 'custom'">{{ $filters.date(dateFilter.start) }} - {{ $filters.date(dateFilter.end) }}</span>
        </button>
    </div>
</template>

<script>
export default {
    props: ['dateFilter'],
    emits: ['click'],
    methods: {
        onClick() {
            this.$emit('click')
        },
    },
}
</script>
